import { Checkbox, TableCell, TableRow } from "@mui/material";
import React from "react";
import * as types from "./types";

export interface ProgressTableRowProps {
	selected: string[];
	handleClick: (event: React.MouseEvent<unknown>, activity: string) => void;
	row: types.UserActivity;
	labelId: string;
}

export const ProgressTableRow = ({
	selected,
	row,
	handleClick,
	labelId,
}: ProgressTableRowProps): JSX.Element => {
	const isSelected = (activity: string): boolean =>
		selected.indexOf(activity) !== -1;

	const isItemSelected = isSelected(row.activity);

	return (
		<TableRow
			hover
			role="checkbox"
			aria-checked={isItemSelected}
			key={row.activity}
			selected={isItemSelected}
		>
			<TableCell padding="checkbox">
				<Checkbox
					checked={isItemSelected}
					data-testid="checkbox"
					inputProps={{ "aria-labelledby": labelId }}
					onClick={(event) => handleClick(event, row.activity)}
				/>
			</TableCell>
			<TableCell padding="none" data-testid="activity">
				{row.activity}
			</TableCell>
			<TableCell padding="none" data-testid="assignment">
				{row.assignment}
			</TableCell>
			<TableCell padding="none" data-testid="accuracy">
				{row.accuracy}
			</TableCell>
			<TableCell padding="none" data-testid="progress">
				{row.progress}
			</TableCell>
			<TableCell padding="none" data-testid="time">
				{row.time}
			</TableCell>
		</TableRow>
	);
};
